export default __webpack_public_path__ + "static/media/craftmen_gray_1.ab744221.png";